export const isContained = use => use === 'enclosed' || use === 'enclosed-shaded' || use === 'flush' || use === 'toolbar';
export const getSelectedTabBackgroundColor = use => {
  return use === 'enclosed-shaded' ? 'fill-transitional-tabs-default' : 'fill-field-default-alt';
};